import { useCallback, useEffect, useState } from "react";
import { listBdcDcs } from "../../services";
import { BdcDc } from "../../types/bdc.type";
import { rowsOf } from "./format";

/** The DC master, for filter dropdowns and the settings tab. */
export function useBdcDcs() {
  const [dcs, setDcs] = useState<BdcDc[]>([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const {
        data: { data },
      } = await listBdcDcs();
      setDcs(rowsOf(data).slice().sort((a, b) => a.dc_code.localeCompare(b.dc_code)));
    } catch {
      // interceptor reported it; an empty dropdown still leaves "ทุก DC"
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { dcs, loading, reload, setDcs };
}
